import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-728854f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Scheduled Prices", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "No scheduled price changes are set for this agreement.", -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field_scheduled_price = _resolveComponent("form-field-scheduled-price")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_form, {
      "on-submit": _ctx.submitPrices,
      ref: "scheduledPricesForm"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localScheduledPrices, (price, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["price-item", { 'hidden': price.delete }])
          }, [
            _createVNode(_component_form_field_scheduled_price, {
              modelValue: _ctx.localScheduledPrices[index],
              "onUpdate:modelValue": ($event: any) => ((_ctx.localScheduledPrices[index]) = $event),
              "context-prices": _ctx.localScheduledPrices,
              "context-agreement-id": _ctx.agreementId,
              "onScheduledPrices:revalidateForm": _ctx.revalidateForm
            }, null, 8, ["modelValue", "onUpdate:modelValue", "context-prices", "context-agreement-id", "onScheduledPrices:revalidateForm"]),
            _createVNode(_component_q_btn, {
              onClick: ($event: any) => (_ctx.removePrice(index)),
              label: "Remove",
              color: "negative",
              "no-caps": "",
              unelevated: ""
            }, null, 8, ["onClick"])
          ], 2))
        }), 128)),
        (!_ctx.localScheduledPrices.filter((p) => !p.delete).length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createVNode(_component_q_btn, {
          onClick: _ctx.addPrice,
          label: "Add Scheduled Price",
          color: "positive",
          "no-caps": "",
          unelevated: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_q_card_actions, {
          align: "right",
          class: "q-mt-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              onClick: _ctx.submitPrices,
              label: "Submit",
              color: "primary",
              "no-caps": "",
              unelevated: ""
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              onClick: _ctx.onCancelClick,
              color: "primary",
              label: "Cancel",
              outline: "",
              "no-caps": ""
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["on-submit"])
  ]))
}